/**
 * <subscription-option>
 *
 * Checkbox "Im Abo bestellen" + interval select above the add-to-cart button. Ticking the box enables the
 * hidden `selling_plan` input inside the product form, so the add-to-cart request carries the plan. Shows the
 * price per delivery for the chosen plan and keeps it in sync when the variant changes.
 */
if (!customElements.get('subscription-option')) {
  class SubscriptionOption extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-subscription-toggle]');
      this.options = this.querySelector('[data-subscription-options]');
      this.select = this.querySelector('[data-subscription-plan]');
      this.input = this.querySelector('[data-subscription-input]');
      this.priceEl = this.querySelector('[data-subscription-price]');
      this.variantId = this.dataset.variantId;
      try {
        this.allocations = JSON.parse(this.querySelector('[data-subscription-allocations]').textContent);
      } catch (error) {
        this.allocations = {};
      }
      this.toggle.addEventListener('change', () => this.update());
      this.select.addEventListener('change', () => this.update());
      this.onVariantChanged = (event) => {
        const id = event.detail?.variant?.id;
        if (id) {
          this.variantId = String(id);
          this.update();
        }
      };
      document.addEventListener('variant:changed', this.onVariantChanged);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChanged);
    }

    format(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }

    update() {
      const on = this.toggle.checked;
      this.options.hidden = !on;
      this.input.disabled = !on;
      this.input.value = on ? this.select.value : '';
      const cents = this.allocations[this.variantId]?.[this.select.value];
      if (on && Number.isFinite(cents)) {
        this.priceEl.textContent = this.dataset.priceTemplate.replace('__PRICE__', this.format(cents));
        this.priceEl.hidden = false;
      } else {
        this.priceEl.hidden = true;
      }
    }
  }
  customElements.define('subscription-option', SubscriptionOption);
}
